import { Loan, Tier, UnitBonusStep } from '../types/commission';

export function formatCurrency(value: number, maximumFractionDigits = 0): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits,
    minimumFractionDigits: 0,
  }).format(value);
}

export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(new Date(`${iso}T12:00:00`));
}

/** Highest unit-bonus step the producer has reached with the given closed-unit count. */
export function activeStep(tier: Tier, units: number): UnitBonusStep {
  return tier.steps.reduce((acc, step) => (units >= step.units ? step : acc), tier.steps[0]);
}

/** Next step still available, or null when the top step is already earned. */
export function nextStep(tier: Tier, units: number): UnitBonusStep | null {
  return tier.steps.find((step) => units < step.units) ?? null;
}

/** Closed units required to unlock the first unit-bonus step in a tier. */
export function minBonusUnits(tier: Tier): number {
  return tier.steps.find((step) => step.bonusBps > 0)?.units ?? 0;
}

export function commissionFor(amount: number, bps: number): number {
  return (amount * bps) / 10000;
}

export function countUnits(loans: Loan[]): number {
  return loans.filter((loan) => loan.countsAsUnit).length;
}

export function sumVolume(loans: Loan[]): number {
  return loans.reduce((total, loan) => total + loan.amount, 0);
}
